// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"145":"tree-page","319":"not-found-page"}[chunkId] || chunkId) + "." + {"145":"5ce40138","255":"c36bc20e","319":"cc13d3da"}[chunkId] + ".chunk.js";
};